import React, { useContext } from 'react'
import { StateContext } from '../../services/StateService'
import ContentCTA from '@3mcom/mds-library/dist/node/ContentCTA'
import ServiceLocator from './ServiceLocator'
import '../../css/PostPurchaseWidget.scss'

/**
 * PostPurchaseWidget renders the MDS Content CTA zone for post-purchase service locator support.
 * Active only when postPurchaseZone.postPurchaseWidget is true (AttrH1599=Yes).
 * Triggers the Wavia/CC service locator fly-in widget via the cc-sf-button anchor.
 */
const PostPurchaseWidget = () => {
    const { postPurchaseZone, ctaInfo } = useContext(StateContext)
    const { postPurchaseFormLabel, postPurchaseFormTitle, postPurchaseFormDescription } =
        postPurchaseZone || {}
    const { serviceLocatorWidgetId, serviceLocatorSubId } = ctaInfo || {}

    if (!postPurchaseFormLabel || !postPurchaseFormTitle || !postPurchaseFormDescription) return null

    // Guard: service locator unavailable → zone not rendered
    if (!serviceLocatorWidgetId || !serviceLocatorSubId) return null

    return (
        <div className="sps2-pdp_section sps2-pdp_postPurchaseWidget">
            <ContentCTA
                title={postPurchaseFormTitle}
                tag="h3"
                cta1_text={postPurchaseFormLabel}
                cta1_ariaLabel={postPurchaseFormLabel}
                content={postPurchaseFormDescription}
                cta1_href="#servicelocator"
                cta1_buttonType="secondary"
                cta1_icon="icon_navigation_pin"
                cta1_className="cc-sf-button"
                contentAlignment="center"
            />
            <ServiceLocator
                widgetId={serviceLocatorWidgetId}
                subId={serviceLocatorSubId}
            />
        </div>
    )
}

export default PostPurchaseWidget
